(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8830],{

/***/ 1345:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/topic/[hashTag]",
      function () {
        return __webpack_require__(44275);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 44275:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _hashTag_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/error/ErrorPage.tsx
var ErrorPage = __webpack_require__(55852);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/deepstash-ui/esm/index.js + 78 modules
var esm = __webpack_require__(40643);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-html-parser/lib/index.js
var lib = __webpack_require__(30653);
// EXTERNAL MODULE: ./src/services/analytics/index.ts
var analytics = __webpack_require__(62687);
// EXTERNAL MODULE: ./src/components/animation/Lottie.jsx
var Lottie = __webpack_require__(71137);
// EXTERNAL MODULE: ./src/components/banner/GetTheAppBanner.tsx
var GetTheAppBanner = __webpack_require__(26202);
// EXTERNAL MODULE: ./src/components/cards/PreviewCardSmall.tsx
var PreviewCardSmall = __webpack_require__(84768);
// EXTERNAL MODULE: ./src/components/idea-card/IdeaCard.tsx + 4 modules
var IdeaCard = __webpack_require__(63848);
// EXTERNAL MODULE: ./src/components/image/NextImage.tsx + 11 modules
var NextImage = __webpack_require__(91260);
// EXTERNAL MODULE: ./src/components/layout/Layout.tsx + 6 modules
var Layout = __webpack_require__(28146);
// EXTERNAL MODULE: ./src/utils/normalizers/hashtag.ts
var hashtag = __webpack_require__(51912);
// EXTERNAL MODULE: ./src/utils/global.ts
var global = __webpack_require__(63069);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/components/social/ProfileCard.tsx
var ProfileCard = __webpack_require__(24839);
// EXTERNAL MODULE: ./src/utils/strings/commonStrings.ts
var commonStrings = __webpack_require__(51599);
// EXTERNAL MODULE: ./src/components/metacontent/components/SubsectionHeader.tsx
var SubsectionHeader = __webpack_require__(17005);
;// CONCATENATED MODULE: ./src/components/metacontent/sections/TopStashersSection.tsx









var TopStashersSection = function(_param) {
    var topStashers = _param.topStashers, rightHeaderElement = _param.rightHeaderElement, props = (0,_object_without_properties/* default */.Z)(_param, [
        "topStashers",
        "rightHeaderElement"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubsectionHeader/* default */.Z, {
                        children: commonStrings/* default.metacontent.topStashersSectionHeader */.Z.metacontent.topStashersSectionHeader
                    }),
                    rightHeaderElement
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                flexDir: "column",
                width: "100%",
                gridGap: esm.spacing.M.rem,
                children: topStashers.map(function(user) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileCard/* default */.Z, {
                        user: user,
                        size: "sm"
                    }, user.id);
                })
            })
        ]
    }));
};
/* harmony default export */ var sections_TopStashersSection = (TopStashersSection);

// EXTERNAL MODULE: ./src/components/hashtag/HashtagChipCarousel.tsx
var HashtagChipCarousel = __webpack_require__(41914);
;// CONCATENATED MODULE: ./src/components/metacontent/sections/RelatedTopicsSection.tsx










var RelatedTopicsSection = function(_param) {
    var hashtags = _param.hashtags, rightHeaderElement = _param.rightHeaderElement, props = (0,_object_without_properties/* default */.Z)(_param, [
        "hashtags",
        "rightHeaderElement"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubsectionHeader/* default */.Z, {
                        height: esm.spacing.toRem(global/* SQUARE_WIDTH */.HC - 4),
                        children: commonStrings/* default.metacontent.relatedTopicsSectionHeader */.Z.metacontent.relatedTopicsSectionHeader
                    }),
                    rightHeaderElement
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HashtagChipCarousel/* default */.Z, {
                hashtags: hashtags,
                pt: esm.spacing.toRem(4)
            })
        ]
    }));
};
/* harmony default export */ var sections_RelatedTopicsSection = (RelatedTopicsSection);

// EXTERNAL MODULE: ./src/api/Hashtag.ts
var Hashtag = __webpack_require__(38177);
// EXTERNAL MODULE: ./src/components/modals/users-modal/UsersModal.tsx
var UsersModal = __webpack_require__(7494);
// EXTERNAL MODULE: ./src/types/enums.ts
var enums = __webpack_require__(41390);
// EXTERNAL MODULE: ./src/theme/Scrollbar.module.scss
var Scrollbar_module = __webpack_require__(48373);
var Scrollbar_module_default = /*#__PURE__*/__webpack_require__.n(Scrollbar_module);
// EXTERNAL MODULE: ./src/components/chips/Chip.tsx
var Chip = __webpack_require__(34001);
// EXTERNAL MODULE: ./src/utils/strings/actionStrings.ts
var actionStrings = __webpack_require__(89134);
;// CONCATENATED MODULE: ./src/components/metacontent/TopicMetacontent.tsx
















var TopicMetacontent = function(param) {
    var hashtagSourcesApiResponse = param.hashtagSourcesApiResponse;
    var hashtagSources = (0,hashtag/* normalizeHashtagSources */.kq)(hashtagSourcesApiResponse);
    var isTabletView = (0,esm.useIsTabletView)();
    var colorMode = (0,esm.useColorMode)().colorMode;
    var isMobileView = (0,esm.useIsMobileView)();
    var ref = (0,esm.useDisclosure)(), isOpenUsersModal = ref.isOpen, onOpenUsersModal = ref.onOpen, onCloseUsersModal = ref.onClose;
    var ref1 = (0,esm.useDisclosure)(), isOpenTopicsModal = ref1.isOpen, onOpenTopicsModal = ref1.onOpen, onCloseTopicsModal = ref1.onClose;
    var topicName = hashtagSources.hashtag;
    var topStashers = hashtagSources.topStashers, relatedTopics = hashtagSources.relatedTopics;
    var ref2 = (0,react.useState)(relatedTopics), allRelatedTopics = ref2[0], setAllRelatedTopics = ref2[1];
    var onTopStashersClick = function() {
        onOpenUsersModal();
        analytics/* Analytics.logEvent */.c.logEvent({
            eventName: analytics/* Events.consumption.selectTopStashers */.z.consumption.selectTopStashers,
            properties: {
                hashtagName: topicName
            },
            platforms: [
                "amplitude"
            ]
        });
    };
    var renderTopStashersButton = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
            onClick: onTopStashersClick,
            color: esm.color[colorMode].primary.default,
            cursor: "pointer",
            _hover: {
                textDecoration: "underline"
            },
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryTextFonts.small.bold), {
                    children: actionStrings/* default.seeAllStashers */.Z.seeAllStashers
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.CaretRightSvg, {
                    boxSize: "1rem",
                    color: esm.color[colorMode].primary.default
                })
            ]
        });
    };
    var loadAllTopics = function() {
        var ref;
        return (ref = Hashtag/* getRelatedTopics */.w2(topicName)) === null || ref === void 0 ? void 0 : ref.then(function(response) {
            return setAllRelatedTopics(response.objects.map(function(item) {
                return item.name;
            }));
        });
    };
    var onSeeTopicsClick = function() {
        onOpenTopicsModal();
        loadAllTopics();
        analytics/* Analytics.logEvent */.c.logEvent({
            eventName: analytics/* Events.consumption.selectRelatedTopics */.z.consumption.selectRelatedTopics,
            properties: {
                hashtagName: topicName
            },
            platforms: [
                "amplitude"
            ]
        });
    };
    var renderAllTopicsButton = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
            onClick: onSeeTopicsClick,
            color: esm.color[colorMode].primary.default,
            cursor: "pointer",
            _hover: {
                textDecoration: "underline"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryTextFonts.small.bold), {
                    children: actionStrings/* default.seeAllTopics */.Z.seeAllTopics
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.CaretRightSvg, {
                    boxSize: "1rem",
                    color: esm.color[colorMode].primary.default,
                    marginTop: esm.spacing.XXS.rem
                })
            ]
        });
    };
    var renderTopStashersSection = function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_TopStashersSection, (0,_object_spread/* default */.Z)({
            topStashers: topStashers,
            rightHeaderElement: renderTopStashersButton()
        }, props));
    };
    var renderRelatedTopicsSection = function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_RelatedTopicsSection, (0,_object_spread/* default */.Z)({
            hashtags: hashtagSources.relatedTopics.map(function(hashtag) {
                return {
                    name: hashtag
                };
            }),
            rightHeaderElement: renderAllTopicsButton()
        }, props));
    };
    var usersModal = isOpenUsersModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(UsersModal/* default */.Z, {
        isOpen: isOpenUsersModal,
        title: "Top stashers in #".concat(hashtagSources.hashtag),
        onClose: onCloseUsersModal,
        data: hashtagSources.topStashers,
        id: hashtagSources.hashtag,
        usecase: enums/* UsersModalType.TOP_STASHERS */.X3.TOP_STASHERS
    }) : null;
    var topicsModal = isOpenTopicsModal ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Modal, {
        isOpen: isOpenTopicsModal,
        onClose: onCloseTopicsModal,
        borderRadius: "1rem",
        backgroundColor: esm.color[colorMode].surface,
        height: "60vh",
        maxWidth: "28rem",
        width: {
            base: "calc(100% - 1rem)",
            lg: "40vw"
        },
        modalBodyProps: {
            className: colorMode === "light" ? (Scrollbar_module_default()).scrollVerticalLightSurface : (Scrollbar_module_default()).scrollVerticalDarkSurface
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                color: esm.color[colorMode].text,
                width: "100%",
                justifyContent: "flex-start",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryHeading, {
                    size: "h2",
                    textSize: isMobileView ? "s" : "m",
                    type: "bold",
                    children: "Related topics in #".concat(hashtagSources.hashtag)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                marginTop: "1rem",
                flexWrap: "wrap",
                gridGap: esm.spacing.XS.rem,
                children: allRelatedTopics.map(function(topic) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                        onClick: onCloseTopicsModal,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                            content: "#".concat(topic),
                            href: "/topic/".concat(topic),
                            m: "unset"
                        })
                    }, "related-topics-modal-item-".concat(topic));
                })
            })
        ]
    }) : null;
    if (isTabletView) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
            width: "100%",
            gridGap: esm.spacing.XXXL.rem,
            mb: esm.spacing.XXXL.rem,
            children: [
                (topStashers === null || topStashers === void 0 ? void 0 : topStashers.length) > 0 && renderTopStashersSection({
                    width: (0,global/* getRemWidthFromColumns */._P)(4)
                }),
                (relatedTopics === null || relatedTopics === void 0 ? void 0 : relatedTopics.length) > 0 && renderRelatedTopicsSection({
                    width: (0,global/* getRemWidthFromColumns */._P)(4)
                }),
                usersModal,
                topicsModal
            ]
        });
    }
    if (isMobileView) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
            flexDirection: "column",
            width: "100%",
            gridGap: esm.spacing.XXXL.rem,
            mb: esm.spacing.XXXL.rem,
            children: [
                (topStashers === null || topStashers === void 0 ? void 0 : topStashers.length) > 0 && renderTopStashersSection(),
                (relatedTopics === null || relatedTopics === void 0 ? void 0 : relatedTopics.length) > 0 && renderRelatedTopicsSection(),
                usersModal,
                topicsModal
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
        flexDirection: "column",
        width: "100%",
        gridGap: esm.spacing.M.rem,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                flexDirection: "column",
                width: "100%",
                gridGap: esm.spacing.XXXL.rem,
                children: [
                    (topStashers === null || topStashers === void 0 ? void 0 : topStashers.length) > 0 && renderTopStashersSection({
                        width: "100%"
                    }),
                    (relatedTopics === null || relatedTopics === void 0 ? void 0 : relatedTopics.length) > 0 && renderRelatedTopicsSection({
                        width: "100%"
                    })
                ]
            }),
            usersModal,
            topicsModal
        ]
    });
};
/* harmony default export */ var metacontent_TopicMetacontent = (TopicMetacontent);

// EXTERNAL MODULE: ./src/components/navigation/NextLink.tsx
var NextLink = __webpack_require__(50752);
// EXTERNAL MODULE: ./src/components/source/source-collapsed/SourceCollapsed.tsx + 2 modules
var SourceCollapsed = __webpack_require__(85611);
// EXTERNAL MODULE: ./src/components/story/StoryCard.tsx
var StoryCard = __webpack_require__(82049);
// EXTERNAL MODULE: ./src/theme/animations/landing_1.json
var landing_1 = __webpack_require__(56642);
// EXTERNAL MODULE: ./src/theme/animations/landing_2.json
var landing_2 = __webpack_require__(96466);
// EXTERNAL MODULE: ./src/theme/animations/landing_3.json
var landing_3 = __webpack_require__(46265);
// EXTERNAL MODULE: ./src/utils/metadata.utils.ts
var metadata_utils = __webpack_require__(83337);
// EXTERNAL MODULE: ./src/utils/normalizers/source.ts + 1 modules
var normalizers_source = __webpack_require__(27079);
// EXTERNAL MODULE: ./src/page-components/landing/StoreRatingCard.tsx
var StoreRatingCard = __webpack_require__(88250);
// EXTERNAL MODULE: ./src/page-components/landing/illustrations/LandingIllustration1.tsx
var LandingIllustration1 = __webpack_require__(55005);
// EXTERNAL MODULE: ./src/page-components/landing/illustrations/LandingIllustration2.tsx
var LandingIllustration2 = __webpack_require__(97558);
// EXTERNAL MODULE: ./src/page-components/landing/illustrations/LandingIllustration3.tsx
var LandingIllustration3 = __webpack_require__(92115);
// EXTERNAL MODULE: ./src/page-components/source/components/CollectionInHeader.tsx
var CollectionInHeader = __webpack_require__(84803);
// EXTERNAL MODULE: ./src/page-components/topic/components/TopicContentNSI.tsx
var TopicContentNSI = __webpack_require__(15635);
// EXTERNAL MODULE: ./src/utils/metatopics.constants.ts
var metatopics_constants = __webpack_require__(90031);
;// CONCATENATED MODULE: ./src/page-components/topic/TopicPageNSI.tsx
































var PHONE_IMAGE_URL = "https://static.deepstash.com/phone-landing-image.png";
var CURATORS_IMAGE_URL = "https://static.deepstash.com/images/web/misc/social-ad.webp";
var RELATED_TOPICS = [
    {
        id: 1,
        exploreId: "hashtag-productivity",
        name: "Productivity",
        image: "https://static.deepstash.com/illustrations/topics/svg/202305/productivity.svg",
        categoryOrder: 0
    },
    {
        id: 6,
        exploreId: "hashtag-psychology",
        name: "Psychology",
        image: "https://static.deepstash.com/illustrations/topics/svg/202305/psychology.svg",
        categoryOrder: 0
    },
    {
        id: 18,
        exploreId: "hashtag-education",
        name: "Education",
        image: "https://static.deepstash.com/illustrations/topics/svg/202305/education.svg",
        categoryOrder: 0
    },
    {
        id: 4,
        exploreId: "hashtag-loveandrelationships",
        name: "Love and Relationships",
        image: "https://static.deepstash.com/illustrations/topics/svg/202305/loveandrelationships.svg",
        categoryOrder: 0
    },
    {
        id: 13,
        exploreId: "hashtag-leadershipandmanagement",
        name: "Leadership and Management",
        image: "https://static.deepstash.com/illustrations/topics/svg/202305/leadership.svg",
        categoryOrder: 0
    }, 
];
var TopicPageNSI = function(param) {
    var hashtagApi = param.hashtagApi, hashtagSources = param.hashtagSources, stories = param.stories;
    var ref, ref1;
    var ref2 = (0,esm.useColorMode)(), colorMode = ref2.colorMode, setColorMode = ref2.setColorMode;
    var isMobileView = (0,esm.useIsMobileView)();
    var isIos = (0,esm.useDeviceDetect)().isIos;
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        setColorMode("light");
    }, []);
    var ideaCarousel = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3;
        if (!hashtagApi.seo) return null;
        var headings = hashtagApi.seo.headings;
        var ref4;
        return ((ref4 = (ref = hashtagApi.seo) === null || ref === void 0 ? void 0 : (ref1 = ref.blocks) === null || ref1 === void 0 ? void 0 : ref1.length) !== null && ref4 !== void 0 ? ref4 : 0) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
            flexDirection: "column",
            w: "100%",
            justifyContent: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Heading, {
                    mb: esm.spacing.M.rem,
                    size: "h2",
                    children: (0,lib/* default */.ZP)(headings[2])
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                    gridGap: global/* GAP_SIZE_REM */.L3,
                    justifyContent: "left",
                    width: "100%",
                    maxW: {
                        base: "calc(100vw - 64px)",
                        md: "100%"
                    },
                    overflowX: "scroll",
                    alignItems: "flex-start",
                    children: (ref2 = hashtagApi.seo) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.blocks) === null || ref3 === void 0 ? void 0 : ref3.map(function(ideaApiResponse, index) {
                        var normalizedArticle = ideaApiResponse.article ? (0,normalizers_source/* normalizeSource */.Nr)(ideaApiResponse.article) : null;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                            minW: {
                                base: "100%",
                                md: (0,global/* getRemWidthFromColumns */._P)(4)
                            },
                            flexDirection: "column",
                            children: [
                                normalizedArticle && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SubsectionHeader/* default */.Z, {
                                            mb: 0,
                                            children: "Core idea curated from:"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SourceCollapsed/* default */.Z, {
                                            showContext: false,
                                            source: normalizedArticle,
                                            mb: esm.spacing.M.rem
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IdeaCard/* default */.Z, {
                                    minW: {
                                        base: "100%",
                                        md: (0,global/* getRemWidthFromColumns */._P)(4)
                                    },
                                    ideaData: {
                                        idea: (0,normalizers_source/* normalizeIdea */.NA)(ideaApiResponse),
                                        source: normalizedArticle
                                    }
                                })
                            ]
                        }, "idea-".concat(index));
                    })
                })
            ]
        }) : null;
    }, [
        (ref = hashtagApi.seo) === null || ref === void 0 ? void 0 : ref.blocks,
        hashtagApi.seo
    ]);
    if (!hashtagApi.seo) {
        return null;
    }
    var _seo = hashtagApi.seo, headings = _seo.headings, descriptions = _seo.descriptions, img_urls = _seo.img_urls, collections = _seo.collections;
    var numberOfPages = Math.ceil(hashtagSources.meta.total_count / 5.0);
    var hashtagUrlParam = router.query.hashTag;
    var renderPages = function() {
        var arr = [];
        var PAGES_MAX_NAVIGATION = isMobileView ? 1 : 3;
        for(var i = Math.max(1, 1 - PAGES_MAX_NAVIGATION); i <= Math.min(1 + PAGES_MAX_NAVIGATION, numberOfPages); i++){
            arr.push(i);
        }
        arr.push(-1);
        arr.push(numberOfPages);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
            maxW: "100%",
            alignSelf: "center",
            my: global/* GAP_SIZE_REM */.L3,
            children: [
                arr.map(function(element, index) {
                    return element === -1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                        px: esm.spacing.M.rem,
                        py: esm.spacing.XS.rem,
                        mr: esm.spacing.XS.rem,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, {
                            color: esm.color[colorMode].text,
                            children: "..."
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                        href: element === 1 ? "/topic/[hashTag]" : "/topic/[hashTag]/[page]",
                        as: element === 1 ? "/topic/".concat(hashtagUrlParam) : "/topic/".concat(hashtagUrlParam, "/").concat(element),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                            borderRadius: esm.spacing.L.rem,
                            px: esm.spacing.M.rem,
                            py: esm.spacing.XS.rem,
                            mr: esm.spacing.XS.rem,
                            _hover: {
                                cursor: "pointer"
                            },
                            backgroundColor: element === 1 ? esm.color[colorMode].surface : esm.color[colorMode].top,
                            _active: undefined,
                            _focus: undefined,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Link, {
                                _hover: undefined,
                                _focus: undefined,
                                href: element === 1 ? "/topic/".concat(hashtagUrlParam) : "/topic/".concat(hashtagUrlParam, "/").concat(element),
                                color: esm.color[colorMode].text,
                                title: (element || "").toString(),
                                children: element
                            })
                        })
                    }, "pageIndex".concat(index));
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                    href: "/topic/[hashTag]/[page]",
                    as: "/topic/".concat(hashtagUrlParam, "/2"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Link, {
                        _hover: undefined,
                        _focus: undefined,
                        href: "/topic/".concat(hashtagUrlParam, "/2"),
                        color: esm.color[colorMode].text,
                        title: "2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                            px: esm.spacing.XS.rem,
                            py: esm.spacing.toRem(6),
                            mr: esm.spacing.XS.rem,
                            borderRadius: esm.spacing.L.rem,
                            align: "center",
                            justifyContent: "center",
                            color: esm.color[colorMode].textSecondary,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.CaretRightSvg, {})
                        })
                    })
                })
            ]
        });
    };
    var renderTitleTextAndImageSection = function(param) {
        var title = param.title, text = param.text, imageUrl = param.imageUrl, _imagePosition = param.imagePosition, imagePosition = _imagePosition === void 0 ? "down" : _imagePosition, _headingSize = param.headingSize, headingSize = _headingSize === void 0 ? "h2" : _headingSize, _objectFit = param.objectFit, objectFit = _objectFit === void 0 ? "contain" : _objectFit;
        var image = /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
            imageUrl: imageUrl,
            wrapperStyle: {
                width: isMobileView ? "100%" : (0,global/* getRemWidthFromColumns */._P)(4),
                height: isMobileView ? "60vw" : (0,global/* getRemWidthFromColumns */._P)(3),
                marginInline: "auto",
                borderRadius: esm.spacing.M.rem
            },
            objectFit: objectFit
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
            width: {
                base: "100%",
                md: (0,global/* getRemWidthFromColumns */._P)(3),
                lg: (0,global/* getRemWidthFromColumns */._P)(4)
            },
            flexDirection: "column",
            gridGap: global/* GAP_SIZE_REM */.L3,
            color: esm.color[colorMode].text,
            children: [
                imagePosition === "up" && image,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Heading, {
                    size: headingSize,
                    children: title
                }),
                text && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, {
                    color: esm.color[colorMode].textSecondary,
                    children: text
                }),
                imagePosition === "down" && image
            ]
        });
    };
    var initialTextSection = /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
        gridGap: global/* GAP_SIZE_REM */.L3,
        flexDirection: {
            base: "column",
            md: "row"
        },
        children: [
            renderTitleTextAndImageSection({
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: (0,lib/* default */.ZP)(headings[0])
                }),
                text: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: (0,lib/* default */.ZP)(descriptions[0])
                }),
                imageUrl: isMobileView ? img_urls[0] : PHONE_IMAGE_URL,
                objectFit: isMobileView ? "cover" : "contain",
                headingSize: "h1"
            }),
            renderTitleTextAndImageSection({
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: (0,lib/* default */.ZP)(headings[1])
                }),
                text: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: (0,lib/* default */.ZP)(descriptions[1])
                }),
                imageUrl: isMobileView ? PHONE_IMAGE_URL : img_urls[0],
                objectFit: isMobileView ? "contain" : "cover",
                imagePosition: isMobileView ? "down" : "up"
            })
        ]
    });
    var tryTheApp = /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
        gridGap: global/* GAP_SIZE_REM */.L3,
        w: "100%",
        flexDirection: "column",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Heading, {
                size: "h2",
                children: (0,lib/* default */.ZP)(headings[3])
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                size: "lg"
            }, esm.typography.primaryHeadingFonts.small.bold), {
                onClick: function() {
                    router.push("/setup");
                    analytics/* Analytics.logEvent */.c.logEvent({
                        eventName: analytics/* Events.onboarding.tapStart */.z.onboarding.tapStart,
                        properties: {
                            "open-from-element": "topic-page-try-it-for-free-1"
                        },
                        platforms: [
                            "amplitude"
                        ]
                    });
                },
                children: "Start Today"
            })),
            isMobileView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreRatingCard/* default */.Z, {
                    store: isIos ? "ios" : "android",
                    flexGrow: 1,
                    flexShrink: 0,
                    width: "auto",
                    height: "auto"
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                gridGap: (0,global/* getRemWidthFromColumns */._P)(1),
                flexDirection: {
                    sm: "column",
                    md: "row",
                    lg: "row"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreRatingCard/* default */.Z, {
                        store: "ios",
                        flexGrow: 1,
                        flexShrink: 0,
                        width: "auto",
                        height: "auto"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreRatingCard/* default */.Z, {
                        store: "android",
                        flexGrow: 1,
                        flexShrink: 0,
                        width: "auto",
                        height: "auto"
                    })
                ]
            })
        ]
    });
    var renderJourneyValueProp = function(param) {
        var title = param.title, animationData = param.animationData, startingIllustration = param.startingIllustration, direction = param.direction;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
            justifyContent: "space-between",
            gridGap: {
                base: esm.spacing.M.rem,
                md: global/* GAP_SIZE_REM */.L3
            },
            flexDirection: {
                sm: "column",
                md: direction === "left" ? "row" : "row-reverse"
            },
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Heading, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    size: "h2"
                }, esm.typography.primaryHeadingFonts.medium.bold), {
                    color: esm.color.light.text,
                    width: {
                        base: "100%",
                        md: "50%"
                    },
                    textAlign: {
                        sm: "center",
                        md: "unset"
                    },
                    children: title
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                    position: "relative",
                    alignItems: "center",
                    borderRadius: 16,
                    overflow: "hidden",
                    width: {
                        base: "100%",
                        md: "50%"
                    },
                    height: "auto",
                    mx: {
                        sm: 48,
                        md: 0
                    },
                    children: [
                        startingIllustration,
                        animationData && /*#__PURE__*/ (0,jsx_runtime.jsx)(Lottie/* default */.Z, {
                            style: {
                                position: "relative",
                                // width: '100%',
                                // height: '100%',
                                cursor: "default",
                                bgColor: "blue"
                            },
                            options: {
                                loop: true,
                                autoplay: false,
                                animationData: animationData
                            },
                            isClickToPauseDisabled: true,
                            speed: 1
                        })
                    ]
                })
            ]
        });
    };
    var journeyValueProps = /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
        flexDirection: "column",
        gridGap: global/* GAP_SIZE_REM */.L3,
        children: [
            renderJourneyValueProp({
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: (0,lib/* default */.ZP)(headings[4])
                }),
                animationData: landing_3,
                startingIllustration: /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingIllustration3/* default */.Z, {
                    position: "absolute"
                }),
                direction: "right"
            }),
            renderJourneyValueProp({
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: (0,lib/* default */.ZP)(headings[5])
                }),
                animationData: landing_2,
                startingIllustration: /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingIllustration2/* default */.Z, {
                    position: "absolute"
                }),
                direction: "left"
            })
        ]
    });
    var journeys = /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
        flexDirection: "column",
        gridGap: global/* GAP_SIZE_REM */.L3,
        children: [
            collections.map(function(journey, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionInHeader/* default */.Z, {
                    collection: journey,
                    showStartJourneyButton: true,
                    topic: hashtagApi.title
                }, "journey-".concat(index));
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                borderRadius: esm.spacing.toRem(16),
                backgroundColor: "#237CAE",
                color: esm.color.light.textInverted,
                w: "100%",
                height: esm.spacing.toRem(160),
                paddingX: esm.spacing.M.rem,
                overflow: "hidden",
                justifyContent: "space-between",
                alignItems: "flex-end",
                cursor: "pointer",
                onClick: function() {
                    return router.push("/get-pro");
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                        flexDirection: "column",
                        padding: esm.spacing.S.rem,
                        marginBottom: esm.spacing.M.rem,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryHeadingFonts.medium.semiBold), {
                                children: "Start 100+ Journeys"
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryTextFonts.large.regular), {
                                children: "Covering over 50 topics"
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                alignItems: "center",
                                marginTop: esm.spacing.M.rem,
                                gridGap: esm.spacing.XS.rem
                            }, esm.typography.primaryTextFonts.large.semiBold), {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.ArrowLeftSvg, {
                                        transform: "rotate(180deg)"
                                    }),
                                    "Get Deepstash Pro"
                                ]
                            }))
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
                        imageUrl: "https://static.deepstash.com/images/web/misc/unlimited-journeys-cover.png",
                        wrapperStyle: {
                            width: "204px",
                            height: "150px"
                        }
                    })
                ]
            })
        ]
    });
    var communityValueProps = /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
        flexDirection: "column",
        gridGap: global/* GAP_SIZE_REM */.L3,
        children: [
            renderJourneyValueProp({
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: (0,lib/* default */.ZP)(headings[6])
                }),
                startingIllustration: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
                    imageUrl: CURATORS_IMAGE_URL,
                    wrapperStyle: {
                        width: isMobileView ? "100%" : (0,global/* getRemWidthFromColumns */._P)(4),
                        height: isMobileView ? "50vw" : (0,global/* getRemWidthFromColumns */._P)(2.5),
                        marginInline: "auto"
                    },
                    objectFit: "cover"
                }),
                direction: "right"
            }),
            renderJourneyValueProp({
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: (0,lib/* default */.ZP)(headings[7])
                }),
                animationData: landing_1,
                startingIllustration: /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingIllustration1/* default */.Z, {
                    position: "absolute"
                }),
                direction: "left"
            })
        ]
    });
    var renderTopicCarousel = function(param) {
        var topics = param.topics;
        return topics.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
            w: "100%",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
            gridGap: global/* GAP_SIZE_REM */.L3,
            pb: {
                base: esm.spacing.M.rem,
                md: 0
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Heading, {
                    size: "h2",
                    textAlign: "center",
                    children: [
                        "Looking to explore even more ideas?",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "Why not",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            style: {
                                color: esm.color.light.primary["default"]
                            },
                            children: "check out related topics:"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                    gridGap: global/* GAP_SIZE_REM */.L3,
                    justifyContent: "left",
                    maxW: {
                        base: "calc(100vw - 64px)",
                        md: "100%"
                    },
                    overflowX: "scroll",
                    alignItems: "flex-start",
                    children: topics.map(function(topic, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewCardSmall/* default */.Z, {
                            w: "160px",
                            h: "160px",
                            name: topic.name,
                            imageUrl: topic.image,
                            gridColumn: {
                                base: (index + 1) % 2,
                                md: (index + 1) % 4
                            },
                            targetUrl: "/topic/" + (0,global/* formatStringToHashtagCase */.J)(topic.name),
                            hasShadow: false,
                            p: esm.spacing.M.rem
                        }, topic.id);
                    })
                })
            ]
        }) : null;
    };
    var renderStoryCarousel = function(param) {
        var stories = param.stories;
        return stories.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
            w: "100%",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
            gridGap: global/* GAP_SIZE_REM */.L3,
            pb: {
                base: esm.spacing.M.rem,
                md: 0
            },
            mb: {
                base: global/* SECTION_GAP_REM */.hM,
                md: 0
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Heading, {
                    size: "h2",
                    textAlign: "center",
                    children: "Check out our latest Stories & Blog Entries"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                    gridGap: global/* GAP_SIZE_REM */.L3,
                    justifyContent: "left",
                    maxW: {
                        base: "calc(100vw - 64px)",
                        md: "100%"
                    },
                    overflowX: "scroll",
                    alignItems: "flex-start",
                    children: stories.map(function(story, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StoryCard/* default */.Z, {
                            story: story,
                            imageWidth: "100%",
                            imageHeight: 160,
                            minW: 160
                        }, "story-".concat(index));
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryButton, {
                    onClick: function() {
                        return router.push("/stories");
                    },
                    children: "Check out more Stories here"
                })
            ]
        }) : null;
    };
    var topicPageSection = {
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
            maxW: "100%",
            w: {
                base: "calc(100vw - 64px)",
                md: "100%"
            },
            overflowX: "hidden",
            flexDirection: "column",
            gridGap: global/* SECTION_GAP_REM */.hM,
            children: [
                initialTextSection,
                ideaCarousel,
                tryTheApp,
                journeyValueProps,
                journeys,
                communityValueProps,
                renderTopicCarousel({
                    topics: RELATED_TOPICS
                }),
                renderStoryCarousel({
                    stories: stories
                })
            ]
        }),
        metaContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(GetTheAppBanner/* default */.Z, {
            isNsi: true
        }),
        metaContentTopOffset: 32,
        metaContentStickyOffset: 32
    };
    var topicContentSection = {
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
            w: "100%",
            flexDirection: "column",
            gridGap: global/* GAP_SIZE_REM */.L3,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Heading, {
                    size: "h2",
                    textAlign: "center",
                    children: "Browse through all Ideas, Tips, Facts & Insights"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TopicContentNSI/* default */.Z, {
                    sources: hashtagSources.objects.map(function(apiSource) {
                        return (0,normalizers_source/* normalizeSource */.Nr)(apiSource);
                    })
                }),
                renderPages()
            ]
        }),
        metaContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(metacontent_TopicMetacontent, {
            hashtagSourcesApiResponse: hashtagSources
        }),
        metaContentTopOffset: 96,
        metaContentStickyOffset: 32,
        sectionStyle: {
            marginTop: global/* SECTION_GAP_REM */.hM
        }
    };
    var ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
        pageMetadata: (0,metadata_utils/* getTopicPageMetadata */.$A)({
            topicTitle: hashtagApi.title,
            topicName: hashtagApi.name,
            pageTitle: hashtagApi.seo_title,
            pageDescription: hashtagApi.seo_description
        }),
        sections: [
            topicPageSection,
            topicContentSection
        ],
        breadcrumbs: [
            {
                title: "Home",
                link: "/"
            },
            {
                title: (ref3 = (ref1 = metatopics_constants/* UNSORTED_TOPICS */.Ay[hashtagApi.name]) === null || ref1 === void 0 ? void 0 : ref1.title) !== null && ref3 !== void 0 ? ref3 : hashtagApi.name,
                link: "/topic/".concat(hashtagApi.name)
            }, 
        ],
        disableProAd: true
    });
};
/* harmony default export */ var topic_TopicPageNSI = (TopicPageNSI);

// EXTERNAL MODULE: ./src/hooks/useInfiniteScroll.ts
var useInfiniteScroll = __webpack_require__(4428);
// EXTERNAL MODULE: ./src/providers/hooks/useAuth.ts + 1 modules
var useAuth = __webpack_require__(79139);
// EXTERNAL MODULE: ./src/providers/hooks/useLayoutContext.ts
var useLayoutContext = __webpack_require__(74649);
// EXTERNAL MODULE: ./src/page-components/topic/components/TopicHeaderV2.tsx
var TopicHeaderV2 = __webpack_require__(77277);
// EXTERNAL MODULE: ./src/utils/strings/pageStrings.ts
var pageStrings = __webpack_require__(23244);
// EXTERNAL MODULE: ./src/components/list/infinite-list/InfiniteList.tsx
var InfiniteList = __webpack_require__(82683);
// EXTERNAL MODULE: ./src/components/source/source-collapsed-placeholder/SourceCollapsedPlaceholder.tsx
var SourceCollapsedPlaceholder = __webpack_require__(95143);
// EXTERNAL MODULE: ./src/components/banner/SignUpBanner.tsx
var SignUpBanner = __webpack_require__(31072);
;// CONCATENATED MODULE: ./src/page-components/topic/components/TopicContent.tsx













var TopicContent = function(param) {
    var sources = param.sources;
    var isLoggedIn = (0,useAuth/* default */.Z)().isLoggedIn;
    var isDesktopView = (0,esm.useIsDesktopView)();
    var getHref = (0,react.useCallback)(function(source) {
        return "/article/".concat(source.id, "/").concat((0,global/* slugify */.lV)(source.title));
    }, []);
    var onPreviewClick = function(source) {
        analytics/* Analytics.logEvent */.c.logEvent({
            eventName: analytics/* Events.consumption.sourcePreviewClick */.z.consumption.sourcePreviewClick,
            properties: {
                sourceId: source.id,
                element: "preview-idea",
                location: "hashtag-screen"
            },
            platforms: [
                "amplitude"
            ]
        });
    };
    var renderItem = function(source, index) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
            onClick: function() {
                return onPreviewClick(source);
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                href: getHref(source),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SourceCollapsed/* default */.Z, {
                    source: source,
                    mb: global/* SQUARE_WIDTH_REM */.wY
                }, source.id)
            })
        }, "topic-source-".concat(source.id, "-").concat(index));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
        pos: "relative",
        zIndex: 3,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SubsectionHeader/* default */.Z, {
                children: commonStrings/* default.allIdeas.toUpperCase */.Z.allIdeas.toUpperCase()
            }),
            sources.length > 0 && renderItem(sources[0], 0),
            sources.length > 1 && renderItem(sources[1], 1),
            !isLoggedIn && !isDesktopView && /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUpBanner/* default */.Z, {
                mb: global/* SQUARE_WIDTH_REM */.wY
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfiniteList/* default */.Z, {
                listKey: "topic",
                data: sources.slice(2),
                paddingThreshold: 5,
                initialNumToRender: 5,
                newItemsThreshold: 5,
                identifier: function(source) {
                    return source.id.toString();
                },
                renderItem: renderItem,
                renderPlaceholder: function(w, h) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SourceCollapsedPlaceholder/* default */.Z, {
                        width: w !== null && w !== void 0 ? w : "unset",
                        h: h !== null && h !== void 0 ? h : "unset"
                    });
                }
            })
        ]
    });
};
/* harmony default export */ var components_TopicContent = (TopicContent);

;// CONCATENATED MODULE: ./src/page-components/topic/TopicPageContent.tsx









var TopicPageContent = function(param) {
    var hashtagSourcesApiResponse = param.hashtagSourcesApiResponse, data = param.data, isFetching = param.isFetching, hasNextPage = param.hasNextPage, isFirstLoading = param.isFirstLoading, target = param.target;
    var colorMode = (0,esm.useColorMode)().colorMode;
    var isLoggedIn = (0,useAuth/* default */.Z)().isLoggedIn;
    var remeasureLayoutCallbackRef = (0,useLayoutContext/* default */.Z)().remeasureLayoutCallbackRef;
    (0,react.useEffect)(function() {
        var ref;
        remeasureLayoutCallbackRef === null || remeasureLayoutCallbackRef === void 0 ? void 0 : (ref = remeasureLayoutCallbackRef.current) === null || ref === void 0 ? void 0 : ref.call(remeasureLayoutCallbackRef);
    }, [
        isLoggedIn
    ]);
    var normalizedHashtag = (0,hashtag/* normalizeHashtagSources */.kq)(hashtagSourcesApiResponse);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            data.length > 0 ? !isLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TopicContentNSI/* default */.Z, {
                sources: data
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TopicContent, {
                sources: data,
                hashtag: normalizedHashtag.hashtag,
                hasNextPage: hasNextPage
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryHeading, {
                size: "h2",
                textSize: "s",
                type: "bold",
                mx: esm.spacing.XXXL.rem,
                color: esm.color[colorMode].textSecondary,
                marginBottom: esm.spacing.XS.rem,
                children: pageStrings/* default.topic.noContentMessage */.Z.topic.noContentMessage
            }),
            !isFirstLoading && !isLoggedIn && isFetching && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                justifyContent: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Spinner, {
                    color: esm.color[colorMode].textSecondary
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                h: "6rem",
                ref: target
            })
        ]
    });
};
/* harmony default export */ var topic_TopicPageContent = (TopicPageContent);

;// CONCATENATED MODULE: ./src/page-components/topic/TopicPageSI.tsx














var TopicPageSI = function(param) {
    var hashtagApi = param.hashtagApi;
    var ref;
    var target = (0,react.useRef)(null);
    var isLoggedIn = (0,useAuth/* default */.Z)().isLoggedIn;
    var remeasureLayoutCallbackRef = (0,useLayoutContext/* default */.Z)().remeasureLayoutCallbackRef;
    var isDesktopView = (0,esm.useIsDesktopView)();
    // moved this up from TopicPage to get here data with all Sources of current topic
    // in order to send to HeadMetadata in Layout a pageDescription that contains the
    // name of one of the sources.
    // Also, if hasthag is null, it will return ErrorPage anyway
    var ref1 = (0,useInfiniteScroll/* default */.Z)({
        firstPageUrl: "/hashtag/name/".concat(hashtagApi === null || hashtagApi === void 0 ? void 0 : hashtagApi.hashtag, "/?limit=5&offset=0"),
        queryKey: [
            "hashtag",
            hashtagApi === null || hashtagApi === void 0 ? void 0 : hashtagApi.hashtag
        ],
        getKey: function(_, previousPageData) {
            var ref;
            // reached the end
            if (previousPageData && previousPageData.objects.length === 0) return undefined;
            var next = (ref = previousPageData.meta.next) === null || ref === void 0 ? void 0 : ref.replace("/api/v2", "");
            return next;
        },
        target: target,
        initialData: hashtagApi,
        maxPageCount: !isLoggedIn ? 1 : undefined
    }), data = ref1.data, isFetching = ref1.isFetching, isFirstLoading = ref1.isFirstLoading, hasNextPage = ref1.hasNextPage;
    var dataArray = (data === null || data === void 0 ? void 0 : data.map(function(page) {
        return page.objects.map(function(source) {
            return (0,normalizers_source/* normalizeSource */.Nr)(source);
        });
    }).reduce(function(prev, val) {
        return prev.concat(val);
    }, [])) || [];
    // here, i get the shortest title out of all sources. If the title is still
    // longer than 70 characters, it's truncated with ellipsis
    var minTitle = (0,react.useMemo)(function() {
        if (dataArray.length > 0) {
            var minTitleSource = dataArray.reduce(function(min, source) {
                if (min === null) {
                    return source;
                } else {
                    if (source.title.length < min.title.length) {
                        return source;
                    } else {
                        return min;
                    }
                }
            });
            return minTitleSource.title.length < 70 ? minTitleSource.title : minTitleSource.title.slice(67) + "...";
        }
        return "";
    }, [
        dataArray
    ]);
    (0,react.useEffect)(function() {
        var ref;
        remeasureLayoutCallbackRef === null || remeasureLayoutCallbackRef === void 0 ? void 0 : (ref = remeasureLayoutCallbackRef.current) === null || ref === void 0 ? void 0 : ref.call(remeasureLayoutCallbackRef);
    }, [
        dataArray.length
    ]);
    var allIdeasSection = {
        infiniteScroll: isLoggedIn || !isDesktopView,
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TopicHeaderV2/* default */.Z, {
                    width: {
                        base: "100%",
                        md: (0,global/* getRemWidthFromColumns */._P)(8)
                    },
                    mb: global/* GAP_SIZE_REM */.L3,
                    hashtagSourcesApiResponse: hashtagApi
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(topic_TopicPageContent, {
                    hashtagSourcesApiResponse: hashtagApi,
                    isFetching: isFetching,
                    isFirstLoading: isFirstLoading,
                    hasNextPage: hasNextPage,
                    data: dataArray,
                    target: target
                })
            ]
        }),
        metaContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(metacontent_TopicMetacontent, {
            hashtagSourcesApiResponse: hashtagApi
        }),
        metaContentTopOffset: 96,
        /**
     * If logged in sticky the top stashers and related topics subsections
     * If not logged in sticky the sign up card
     * This prop is only for the desktop view
     */ metaContentStickyOffset: isLoggedIn ? 32 : -688
    };
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
        pageMetadata: (0,metadata_utils/* getTopicPageMetadata */.$A)({
            topicName: hashtagApi.hashtag,
            topicTitle: hashtagApi.hashtag,
            exampleArticleTitle: minTitle,
            pageTitle: hashtagApi.seo_title,
            pageDescription: hashtagApi.seo_description
        }),
        sections: [
            allIdeasSection
        ],
        breadcrumbs: [
            {
                title: "Home",
                link: "/"
            },
            {
                title: (ref2 = (ref = metatopics_constants/* UNSORTED_TOPICS */.Ay[hashtagApi.hashtag]) === null || ref === void 0 ? void 0 : ref.title) !== null && ref2 !== void 0 ? ref2 : hashtagApi.hashtag,
                link: "/topic/".concat(hashtagApi.hashtag)
            }, 
        ]
    });
};
/* harmony default export */ var topic_TopicPageSI = (TopicPageSI);

;// CONCATENATED MODULE: ./pages/topic/[hashTag].tsx







var TopicDynamicPage = function(param) {
    var topicTag = param.topicTag, hashtagApi = param.hashtagApi, hashtagApiNsi = param.hashtagApiNsi, stories = param.stories;
    (0,react.useEffect)(function() {
        if (topicTag && hashtagApi) {
            analytics/* Analytics.logEvent */.c.logEvent({
                eventName: analytics/* Events.consumption.viewTopic */.z.consumption.viewTopic,
                properties: {
                    topic: topicTag
                },
                platforms: [
                    "amplitude"
                ]
            });
        }
    }, [
        topicTag
    ]);
    if (!topicTag || !hashtagApi) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* default */.Z, {});
    return hashtagApiNsi ? /*#__PURE__*/ (0,jsx_runtime.jsx)(topic_TopicPageNSI, {
        topicTag: topicTag,
        hashtagApi: hashtagApiNsi,
        hashtagSources: hashtagApi,
        stories: stories !== null && stories !== void 0 ? stories : []
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(topic_TopicPageSI, {
        topicTag: topicTag,
        hashtagApi: hashtagApi
    });
};
var __N_SSP = true;
/* harmony default export */ var _hashTag_ = (TopicDynamicPage);


/***/ }),

/***/ 7494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var hooks_useInfiniteScroll__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4428);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var theme_Scrollbar_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48373);
/* harmony import */ var theme_Scrollbar_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(theme_Scrollbar_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var utils_normalizers_profile__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7269);
/* harmony import */ var src_components_user_UserFollowRow__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27903);
/* harmony import */ var src_services_analytics__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62687);








var UsersModal = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose, id = param.id, usecase = param.usecase, dataProp = param.data, titleProp = param.title, updateFollowingNum = param.updateFollowingNum;
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useColorMode)().colorMode;
    var isMobileView = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useIsMobileView)();
    var USER_API_QUERY_SIZE = 20;
    var target = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    var initialUrl = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        switch(usecase){
            case "saves":
                return "/user/saved_block/".concat(id, "/");
            case "followers":
                return "/user/".concat(id, "/followers/");
            case "following":
                return "/user/".concat(id, "/following/");
            // [Like functionality]
            // case 'likes':
            //   return `/user/liked_block/${id}/`;
            case "top-stashers":
                return "/hashtag/top_stashers/".concat(id, "/");
            default:
                return "";
        }
    }, [
        usecase,
        id
    ]);
    var ref = (0,hooks_useInfiniteScroll__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        firstPageUrl: initialUrl,
        queryKey: [
            "userModal",
            usecase,
            id
        ],
        getKey: function(_index, previousPageData) {
            var ref;
            if (!isOpen) return undefined;
            // reached the end
            if (previousPageData && previousPageData.objects.length === 0) return undefined;
            return (ref = previousPageData.meta.next) === null || ref === void 0 ? void 0 : ref.replace("/api/v2", "");
        },
        target: target
    }), data = ref.data, isFetching = ref.isFetching, isFirstLoading = ref.isFirstLoading;
    var modalTitle = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        if (titleProp) {
            return titleProp;
        }
        switch(usecase){
            case "saves":
                return "People who stashed this idea";
            case "followers":
                return "Followers";
            case "following":
                return "Following";
            // [Like functionality]
            // case 'likes':
            //   return 'People who liked this idea';
            default:
                return "";
        }
    }, [
        usecase,
        titleProp
    ]);
    var users = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return data.length === 0 ? dataProp !== null && dataProp !== void 0 ? dataProp : [] : data.map(function(users) {
            return users.objects.map(utils_normalizers_profile__WEBPACK_IMPORTED_MODULE_6__/* .normalizeUserData */ .Te);
        }).flat();
    }, [
        data,
        dataProp
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        // Log the loaded page whenever a new page is loaded.
        // Nothing will be logged for those with no followers.
        if (users.length != 0) src_services_analytics__WEBPACK_IMPORTED_MODULE_5__/* .Analytics.logEvent */ .c.logEvent({
            eventName: src_services_analytics__WEBPACK_IMPORTED_MODULE_5__/* .Events.modals.usersModal */ .z.modals.usersModal,
            properties: {
                type: usecase !== null && usecase !== void 0 ? usecase : "saves",
                pageCount: Math.ceil(users.length / USER_API_QUERY_SIZE)
            },
            platforms: [
                "amplitude"
            ]
        });
    }, [
        users.length
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Modal, {
        isOpen: isOpen,
        onClose: onClose,
        borderRadius: "15px",
        backgroundColor: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].surface,
        height: "60vh",
        maxWidth: "28rem",
        width: {
            base: "calc(100% - 1rem)",
            lg: "40vw"
        },
        modalBodyProps: {
            className: colorMode === "light" ? (theme_Scrollbar_module_scss__WEBPACK_IMPORTED_MODULE_7___default().scrollVerticalLightSurface) : (theme_Scrollbar_module_scss__WEBPACK_IMPORTED_MODULE_7___default().scrollVerticalDarkSurface)
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text,
                width: "95%",
                borderRadius: "15px 15px 0 0",
                top: 0,
                left: 0,
                paddingLeft: "2rem",
                paddingTop: "2rem",
                justifyContent: "flex-start",
                position: "absolute",
                zIndex: 1,
                backgroundColor: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].surface,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryHeading, {
                    size: "h2",
                    textSize: isMobileView ? "s" : "m",
                    type: "bold",
                    children: modalTitle
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Box, {
                mt: "3rem",
                children: [
                    users.map(function(user) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_user_UserFollowRow__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            user: user,
                            onUserClick: onClose,
                            onFollowSuccess: updateFollowingNum,
                            usecase: usecase
                        }, "users-modal-user-row-".concat(user.id));
                    }),
                    !isFirstLoading && isFetching && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Spinner, {
                            color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].textSecondary
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Box, {
                        h: "50px",
                        ref: target
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (UsersModal);


/***/ }),

/***/ 24839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var utils_global__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63069);
/* harmony import */ var _buttons_FollowUserButtonV2__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81089);
/* harmony import */ var _cards_BaseCard__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46039);
/* harmony import */ var _navigation_NextLink__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50752);
/* harmony import */ var _ProfilePicture__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7877);











var ProfileCard = function(_param) {
    var user = _param.user, size = _param.size, withBackground = _param.withBackground, maxNoOfLinesBio = _param.maxNoOfLinesBio, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "user",
        "size",
        "withBackground",
        "maxNoOfLinesBio"
    ]);
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useColorMode)().colorMode;
    var _photo;
    var renderProfilePicture = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_navigation_NextLink__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            href: "/u/".concat(user.username),
            passHref: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Link, {
                _hover: undefined,
                _active: undefined,
                _focus: undefined,
                onClick: utils_global__WEBPACK_IMPORTED_MODULE_3__/* .onLinkClick */ .nt,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ProfilePicture__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    boxSize: "4rem",
                    photo: (_photo = user.photo) !== null && _photo !== void 0 ? _photo : "",
                    size: "xl",
                    altTag: user.username,
                    imageBlurhash: user.photo_blurhash,
                    p: "0",
                    pr: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.M.rem,
                    mb: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.S.rem
                })
            })
        });
    };
    var userInfo = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_navigation_NextLink__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        href: "/u/".concat(user.username),
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Link, {
            _hover: undefined,
            _active: undefined,
            _focus: undefined,
            onClick: utils_global__WEBPACK_IMPORTED_MODULE_3__/* .onLinkClick */ .nt,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                    color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text
                }, deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.typography.primaryHeadingFonts.small.bold), {
                    children: user.firstName + " " + user.lastName
                })),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                    mb: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.S.rem,
                    color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text,
                    opacity: 0.4
                }, deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.typography.primaryTextFonts.small), {
                    children: "@" + user.username
                }))
            ]
        })
    });
    var userBio = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
        color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].textSecondary,
        noOfLines: maxNoOfLinesBio
    }, deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.typography.primaryTextFonts.small), {
        children: user.bio
    }));
    if (size === "lg") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_cards_BaseCard__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
            width: "100%",
            flexDirection: "column",
            bgColor: withBackground ? deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].surface : "unset",
            hasHoverEffect: !!withBackground,
            py: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.XS.rem
        }, props), {
            children: [
                renderProfilePicture(),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                            flexDirection: "column",
                            children: userInfo
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_buttons_FollowUserButtonV2__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            userId: user.id,
                            height: utils_global__WEBPACK_IMPORTED_MODULE_3__/* .SQUARE_WIDTH_REM */ .wY,
                            width: "8rem"
                        })
                    ]
                }),
                userBio
            ]
        }));
    } else {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_cards_BaseCard__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
            width: "100%",
            bgColor: withBackground ? deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].surface : "unset",
            hasHoverEffect: !!withBackground
        }, props), {
            children: [
                renderProfilePicture(),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                    flexDir: "column",
                    children: [
                        userInfo,
                        userBio
                    ]
                })
            ]
        }));
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (ProfileCard);


/***/ }),

/***/ 82049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40643);
/* harmony import */ var _navigation_NextLink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50752);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var utils_global__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63069);
/* harmony import */ var _image_NextImage__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91260);







 // Use it instead of own useRouter for fixing scroll problems


var STORY_IMAGE_SIZE = {
    WIDTH: 260,
    HEIGHT: 180,
    BORDER_RADIUS: 8
};
var StoryCard = function(_param) {
    var story = _param.story, _imageWidth = _param.imageWidth, imageWidth = _imageWidth === void 0 ? STORY_IMAGE_SIZE.WIDTH : _imageWidth, _imageHeight = _param.imageHeight, imageHeight = _imageHeight === void 0 ? STORY_IMAGE_SIZE.HEIGHT : _imageHeight, _imageBorderRadius = _param.imageBorderRadius, imageBorderRadius = _imageBorderRadius === void 0 ? STORY_IMAGE_SIZE.BORDER_RADIUS : _imageBorderRadius, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "story",
        "imageWidth",
        "imageHeight",
        "imageBorderRadius"
    ]);
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.useColorMode)().colorMode;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var storySlug = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(function() {
        return (0,utils_global__WEBPACK_IMPORTED_MODULE_5__/* .slugify */ .lV)(story.title);
    }, [
        story.title
    ]);
    var storyPageRoute = "/story/".concat(story.id, "/").concat(storySlug);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Flex, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        flexDirection: "column",
        width: imageWidth
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_image_NextImage__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                wrapperStyle: {
                    width: imageWidth,
                    height: imageHeight,
                    borderRadius: imageBorderRadius,
                    cursor: "pointer"
                },
                imageUrl: story.image,
                blurhash: story.image_blurhash,
                alt: "".concat(story.title, " Image"),
                priority: false,
                onClick: function() {
                    router.push(storyPageRoute);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.typography.primaryTextFonts.small.regular), {
                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color[colorMode].textSecondary,
                mt: 8,
                children: "".concat(story.time_to_read, " min read")
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_navigation_NextLink__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                href: storyPageRoute,
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Link, {
                    _focus: undefined,
                    _hover: undefined,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.typography.primaryTextFonts.large.bold), {
                        color: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color[colorMode].text,
                        noOfLines: 3,
                        mt: 16,
                        children: "".concat(story.title)
                    }))
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.typography.primaryTextFonts.medium.regular), {
                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color[colorMode].textSecondary,
                noOfLines: 3,
                mt: 16,
                children: "".concat(story.intro)
            }))
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (StoryCard);


/***/ }),

/***/ 84803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40643);
/* harmony import */ var utils_global__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63069);
/* harmony import */ var src_components_image_NextImage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91260);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var src_components_navigation_NextLink__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50752);








 // Use it instead of own useRouter for fixing scroll problems

var COLLECTION_IMAGE_SIZE = {
    WIDTH: 140,
    HEIGHT: 175,
    BORDER_RADIUS: 8
};
var FALLBACK_SKILLS = [
    "How to prioritize tasks effectively",
    "How to minimize distractions",
    "How to optimize your work environment",
    "How to use technology to your advantage",
    "How to delegate tasks efficiently", 
];
var CollectionInHeader = function(_param) {
    var collection = _param.collection, topic = _param.topic, _showStartJourneyButton = _param.showStartJourneyButton, showStartJourneyButton = _showStartJourneyButton === void 0 ? false : _showStartJourneyButton, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "collection",
        "topic",
        "showStartJourneyButton"
    ]);
    var isMobileView = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.useIsMobileView)();
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.useColorMode)().colorMode;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var collectionSlug = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(function() {
        return (0,utils_global__WEBPACK_IMPORTED_MODULE_3__/* .slugify */ .lV)(collection.name);
    }, [
        collection.name
    ]);
    var collectionPageRoute = "/collection/".concat(collection.id, "/").concat(collectionSlug);
    var finalSkills = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(function() {
        return collection.skills !== undefined ? collection.skills : FALLBACK_SKILLS;
    }, [
        collection.skills
    ]);
    var renderSkill = function(param) {
        var skill = param.skill, index = param.index;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Flex, {
            flexDirection: "row",
            alignItems: "flex-start",
            gridColumnGap: 4,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.CheckFillSvg, {
                    color: "green",
                    boxSize: isMobileView ? "24px" : "26px"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, isMobileView ? deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.typography.primaryTextFonts.large.regular : deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.typography.primaryTextFonts.large.regular), {
                    color: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color[colorMode].textSecondary,
                    flex: 1,
                    children: skill
                }))
            ]
        }, "skill-".concat(index));
    };
    var collectionImage = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_image_NextImage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        wrapperStyle: {
            width: COLLECTION_IMAGE_SIZE.WIDTH,
            height: COLLECTION_IMAGE_SIZE.HEIGHT,
            borderRadius: COLLECTION_IMAGE_SIZE.BORDER_RADIUS,
            cursor: "pointer"
        },
        imageUrl: collection.image,
        blurhash: collection.image_blurhash,
        alt: "".concat(collection.name),
        priority: false,
        onClick: function() {
            router.push(collectionPageRoute);
        }
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Flex, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        bgColor: "".concat(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color[colorMode].top, "66"),
        flexDirection: isMobileView ? "column" : "row",
        p: utils_global__WEBPACK_IMPORTED_MODULE_3__/* .GAP_SIZE */ .DG,
        gridGap: utils_global__WEBPACK_IMPORTED_MODULE_3__/* .GAP_SIZE */ .DG,
        borderRadius: 16,
        alignItems: "flex-end"
    }, props), {
        children: [
            isMobileView ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Flex, {
                width: "100%",
                justifyContent: "center",
                children: collectionImage
            }) : collectionImage,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Flex, {
                flex: 1,
                flexDirection: "column",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.typography.primaryTextFonts.large.regular), {
                        color: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color[colorMode].text,
                        children: "Learn more about ".concat(topic, " with this collection")
                    })),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_navigation_NextLink__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        href: collectionPageRoute,
                        passHref: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Link, {
                            _focus: undefined,
                            _hover: {
                                textDecoration: "underline"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.typography.primaryHeadingFonts.medium.bold), {
                                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color[colorMode].text,
                                children: collection.name
                            }))
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Flex, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                        flexDirection: "column",
                        gridRowGap: 8,
                        mt: 16
                    }, isMobileView ? {
                        width: "100%"
                    } : {}), {
                        children: finalSkills.slice(0, 3).map(function(skill, index) {
                            return renderSkill({
                                skill: skill,
                                index: index
                            });
                        })
                    }))
                ]
            }),
            showStartJourneyButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.PrimaryButton, {
                backgroundColor: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color[colorMode].text,
                height: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.spacing.toRem(48),
                width: {
                    base: "100%",
                    md: "auto"
                },
                onClick: function() {
                    return router.push(collectionPageRoute);
                },
                children: "Start Journey"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (CollectionInHeader);


/***/ }),

/***/ 94120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_page_components_landing_components_v2_LandingStartTrialSection__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90182);







var SourceNSIArticleGradient = function(_param) {
    var collection = _param.collection, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "collection"
    ]);
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useColorMode)().colorMode;
    var isMobileView = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useIsMobileView)();
    // const router = useRouter();
    // We make the gradientFooterRef absolute after scrolling past a point.
    var gradientFooterRef = react__WEBPACK_IMPORTED_MODULE_2__.useRef(null);
    // const collectionSlug = React.useMemo(() => {
    //   if (collection === undefined) {
    //     return '';
    //   }
    //   return slugify(collection.name);
    // }, [collection]);
    // const collectionPageRoute = `/collection/${collection?.id}/${collectionSlug}`;
    // const minutesToRead = React.useMemo(() => {
    //   if (collection?.time_to_read !== undefined) {
    //     return formatSecondsToNearestMinute(collection.time_to_read);
    //   }
    //   return undefined;
    // }, [collection]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Box, {
        position: "absolute",
        ref: gradientFooterRef,
        height: "100%",
        width: "100%",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            // position={gradientFooterPosition === 'fixed' ? 'fixed' : 'absolute'}
            position: "absolute",
            zIndex: 5,
            bottom: 0,
            left: 0,
            top: "unset",
            right: 0,
            width: "100%",
            height: {
                base: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(480),
                md: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(600)
            },
            background: "linear-gradient(to top,  ".concat(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].background, " ").concat(isMobileView ? 75 : 60, "%,").concat(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color.transparent, " 100%)"),
            flexDirection: "column",
            justifyContent: collection === undefined ? "flex-end" : "center",
            alignItems: "center",
            pb: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(8)
        }, props), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                px: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(16),
                flexDirection: "column",
                alignItems: "center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_page_components_landing_components_v2_LandingStartTrialSection__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    isCentered: true
                })
            })
        }))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SourceNSIArticleGradient);


/***/ }),

/***/ 15635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var providers_hooks_useAuth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79139);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var src_components_banner_SignUpBanner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31072);
/* harmony import */ var src_components_metacontent_components_SubsectionHeader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17005);
/* harmony import */ var src_components_navigation_NextLink__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50752);
/* harmony import */ var src_components_source_source_collapsed_SourceCollapsed__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85611);
/* harmony import */ var src_page_components_source_components_SourceNSIArticleGradient__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(94120);
/* harmony import */ var src_services_analytics__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(62687);
/* harmony import */ var utils_global__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(63069);
/* harmony import */ var utils_strings_commonStrings__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(51599);












var TopicContentNSI = function(param) {
    var sources = param.sources;
    var isDesktopView = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useIsDesktopView)();
    var isMobileView = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useIsMobileView)();
    var isLoggedIn = (0,providers_hooks_useAuth__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().isLoggedIn;
    var getHref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function(source) {
        return "/article/".concat(source.id, "/").concat((0,utils_global__WEBPACK_IMPORTED_MODULE_10__/* .slugify */ .lV)(source.title));
    }, []);
    var onPreviewClick = function(source) {
        src_services_analytics__WEBPACK_IMPORTED_MODULE_9__/* .Analytics.logEvent */ .c.logEvent({
            eventName: src_services_analytics__WEBPACK_IMPORTED_MODULE_9__/* .Events.consumption.sourcePreviewClick */ .z.consumption.sourcePreviewClick,
            properties: {
                sourceId: source.id,
                element: "preview-idea",
                location: "hashtag-screen"
            },
            platforms: [
                "amplitude"
            ]
        });
    };
    var mainLayoutSectionHeight = !isMobileView ? deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(1400) : "unset";
    var renderItem = function(source, index) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Box, {
            onClick: function() {
                return onPreviewClick(source);
            },
            filter: index > 4 ? "blur(4px)" : "",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_navigation_NextLink__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                href: getHref(source),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_source_source_collapsed_SourceCollapsed__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    source: source,
                    mb: utils_global__WEBPACK_IMPORTED_MODULE_10__/* .SQUARE_WIDTH_REM */ .wY
                }, source.id)
            })
        }, "topic-source-".concat(source.id, "-").concat(index));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Box, {
        pos: "relative",
        zIndex: 3,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Box, {
                height: mainLayoutSectionHeight,
                overflowY: "hidden",
                pos: "relative",
                zIndex: 3,
                children: [
                    !isLoggedIn && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_page_components_source_components_SourceNSIArticleGradient__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_metacontent_components_SubsectionHeader__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        children: utils_strings_commonStrings__WEBPACK_IMPORTED_MODULE_11__/* ["default"].allIdeas.toUpperCase */ .Z.allIdeas.toUpperCase()
                    }),
                    sources.map(function(source, index) {
                        return renderItem(source, index);
                    })
                ]
            }),
            !isLoggedIn && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_banner_SignUpBanner__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                size: isDesktopView ? "lg" : "sm",
                mt: isDesktopView ? utils_global__WEBPACK_IMPORTED_MODULE_10__/* .BLOCK_WIDTH_REM */ .sC : 0,
                mb: isDesktopView ? 0 : utils_global__WEBPACK_IMPORTED_MODULE_10__/* .SQUARE_WIDTH_REM */ .wY
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TopicContentNSI);


/***/ }),

/***/ 77277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_components_image_NextImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91260);
/* harmony import */ var utils_normalizers_hashtag__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51912);
/* harmony import */ var utils_strings_commonStrings__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51599);
/* harmony import */ var utils_strings_pageStrings__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23244);
/* harmony import */ var utils_metatopics_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90031);











var TopicHeaderV2 = function(_param) {
    var hashtagSourcesApiResponse = _param.hashtagSourcesApiResponse, pageNumber = _param.pageNumber, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "hashtagSourcesApiResponse",
        "pageNumber"
    ]);
    var ref;
    var hashtagSources = (0,utils_normalizers_hashtag__WEBPACK_IMPORTED_MODULE_4__/* .normalizeHashtagSources */ .kq)(hashtagSourcesApiResponse);
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useColorMode)().colorMode;
    var isMobileView = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useIsMobileView)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        if (isMobileView) return {
            titleStyle: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.typography.primaryHeadingFonts.small.bold,
            subTitleStyle: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.typography.primaryTextFonts.medium.regular
        };
        return {
            titleStyle: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.typography.primaryHeadingFonts.large.bold,
            subTitleStyle: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.typography.primaryTextFonts.medium.regular
        };
    }, [
        isMobileView
    ]), titleStyle = ref1.titleStyle, subTitleStyle = ref1.subTitleStyle;
    var headerImage = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        // The topic names are different in METATOPICS, so we have to remove the spaces and switch to lower case
        var possibleImageUrls = utils_metatopics_constants__WEBPACK_IMPORTED_MODULE_7__/* .METATOPICS.filter */ .zY.filter(function(topic) {
            return topic.exploreId === "hashtag-".concat(hashtagSources.hashtag);
        }).map(function(topic) {
            return topic.image;
        });
        // We return a component only if we have a topic image
        if (possibleImageUrls.length > 0) {
            var imageUrl = possibleImageUrls[0];
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_image_NextImage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                wrapperStyle: {
                    height: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(64),
                    minWidth: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(64),
                    mr: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.M.rem
                },
                imageUrl: imageUrl,
                alt: hashtagSources.hashtag,
                priority: true,
                isNotInteractable: true
            });
        }
        return null;
    }, [
        hashtagSources.hashtag
    ]);
    var ref2;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
        width: "100%",
        align: "center",
        height: "100%"
    }, props), {
        children: [
            headerImage,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                flexDir: "column",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, titleStyle), {
                            color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text,
                            children: [
                                (ref2 = (ref = utils_metatopics_constants__WEBPACK_IMPORTED_MODULE_7__/* .UNSORTED_TOPICS */ .Ay[hashtagSources.hashtag]) === null || ref === void 0 ? void 0 : ref.title) !== null && ref2 !== void 0 ? ref2 : hashtagSources.hashtag,
                                pageNumber && " - Page ".concat(pageNumber)
                            ]
                        }))
                    }),
                    hashtagSources.totalIdeas && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, subTitleStyle), {
                        mr: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.XXS.rem,
                        color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].textSecondary,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                children: hashtagSources.totalIdeas
                            }),
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                children: utils_strings_commonStrings__WEBPACK_IMPORTED_MODULE_5__/* ["default"].ideas.toLowerCase */ .Z.ideas.toLowerCase()
                            }),
                            " ",
                            utils_strings_pageStrings__WEBPACK_IMPORTED_MODULE_6__/* ["default"].topic.header.onThisTopic */ .Z.topic.header.onThisTopic
                        ]
                    }))
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (TopicHeaderV2);


/***/ }),

/***/ 51912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "aI": function() { return /* binding */ normalizeSearchedHashtag; },
/* harmony export */   "kq": function() { return /* binding */ normalizeHashtagSources; }
/* harmony export */ });
/* unused harmony export normalizeProfessionsWithHashtagsApiResponse */
/* harmony import */ var _source__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27079);
/* harmony import */ var _profile__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7269);


var normalizeHashtagSources = function(hashtag) {
    var ref;
    var ref1;
    return {
        hashtag: hashtag.hashtag,
        meta: hashtag.meta,
        objects: hashtag.objects.map(function(src) {
            return (0,_source__WEBPACK_IMPORTED_MODULE_0__/* .normalizeSource */ .Nr)(src);
        }),
        totalIdeas: hashtag.total_ideas,
        relatedTopics: hashtag.related_hashtags,
        topStashers: (ref1 = (ref = hashtag.top_stashers) === null || ref === void 0 ? void 0 : ref.map(function(apiUser) {
            return (0,_profile__WEBPACK_IMPORTED_MODULE_1__/* .normalizeUserData */ .Te)(apiUser);
        })) !== null && ref1 !== void 0 ? ref1 : [],
        totalRelatedTopics: hashtag.total_related_hashtags,
        totalTopStashers: hashtag.total_top_stashers
    };
};
var normalizeSearchedHashtag = function(searchedHashtag) {
    var ref;
    return {
        sources: (ref = searchedHashtag.articles) === null || ref === void 0 ? void 0 : ref.map(function(article) {
            return (0,_source__WEBPACK_IMPORTED_MODULE_0__/* .normalizeSource */ .Nr)(article);
        }),
        name: searchedHashtag.name,
        totalIdeas: searchedHashtag.total_ideas
    };
};
var normalizeProfessionsWithHashtagsApiResponse = function(response) {
    var finalArray = [];
    response.departments.forEach(function(department) {
        finalArray.push({
            name: department.name,
            workHashtags: department.work_hashtags,
            personalHashtags: department.personal_hashtags,
            trendingHashtags: department.trending_hashtags
        });
    });
    return finalArray;
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [296,7229,9000,9891,9834,5611,2853,3244,3299,7054,9774,2888,179], function() { return __webpack_exec__(1345); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);